import React from "react"
import {useTranslation} from "react-i18next"

import {usePersonGroups as useItems} from "../../../contexts/PersonGroupContext"

import PersonGroup             from "../../../types/PersonGroup"
import LockingSystemPermission from "../../../types/LockingSystemPermission"

import ListItemButtonDelete from "../../common/Buttons/ListItemButtonDelete"

interface props {
    personGroup:             PersonGroup
    lockingSystemPermission: LockingSystemPermission
}

const ButtonDelete: React.FC<props> = ({personGroup, lockingSystemPermission}) => {

    const { t } = useTranslation()

    const {deleteLockingSystemPermission} = useItems()

    const onDelete = async () => {
        await deleteLockingSystemPermission(personGroup, lockingSystemPermission)
    }

    return (
        <ListItemButtonDelete
            headerRemovableTxt={t('personGroupLockingSystemPermissions.alerts.delete.header')}
            headerNotRemovableTxt={t('personGroupLockingSystemPermissions.alerts.delete_not_possible.header')}
            messageRemovableTxt={t('personGroupLockingSystemPermissions.alerts.delete.message')}
            messageNotRemovableTxt={t('personGroupLockingSystemPermissions.alerts.delete_not_possible.message')}
            isRemovable={lockingSystemPermission.options?.isRemovableFromLock}
            onDelete={() => { onDelete() }}
        />
    )
}

export default ButtonDelete